// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-1imhtct-MuiTypography-root {
  line-height: 2.5 !important;
  font-family: "Helvetica Neue", sans-serif !important;
  font-size: 18px;
}
.css-5cqd15-MuiTypography-root {
  font-family: "Helvetica Neue", sans-serif !important;
}
.css-l7qz1a-MuiGrid-root {
  align-items: baseline !important;
}

.css-o4bg9w-MuiGrid-root {
  flex-basis: 124.666667% !important;
  flex-grow: 0;
  max-width: 101.666667% !important;
}

.icon-list {
  display: flex;
  justify-content: flex-start;
}
img.icon-list-img {
  margin-right: 30px;
  width: 50px;
}

span.mins-text {
  color: var(--Primary, #313b2f);
  font-family: "Helvetica Neue", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.icon-list-title {
  color: var(--Black, #000);
  font-family: "Helvetica Neue", sans-serif !important;
  font-size: 20px;
  font-style: normal !important;
  font-weight: 300;
  line-height: 33px !important;
}

.icon-list-heading {
  color: var(--Black, #000);
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  opacity: 0.6;
  font-family: "Helvetica Neue", sans-serif !important;
}

.icon-list {
  margin-bottom: 2rem;
}

.location-options {
  flex-basis: 100.333333% !important;

  max-width: 100.333333% !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/LocationComponent.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,oDAAoD;EACpD,eAAe;AACjB;AACA;EACE,oDAAoD;AACtD;AACA;EACE,gCAAgC;AAClC;;AAEA;EAGE,kCAAkC;EAIlC,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;EACpD,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;;EAElC,iCAAiC;AACnC","sourcesContent":[".css-1imhtct-MuiTypography-root {\n  line-height: 2.5 !important;\n  font-family: \"Helvetica Neue\", sans-serif !important;\n  font-size: 18px;\n}\n.css-5cqd15-MuiTypography-root {\n  font-family: \"Helvetica Neue\", sans-serif !important;\n}\n.css-l7qz1a-MuiGrid-root {\n  align-items: baseline !important;\n}\n\n.css-o4bg9w-MuiGrid-root {\n  -webkit-flex-basis: 66.666667%;\n  -ms-flex-preferred-size: 66.666667%;\n  flex-basis: 124.666667% !important;\n  -webkit-box-flex: 0;\n  -webkit-flex-grow: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  max-width: 101.666667% !important;\n}\n\n.icon-list {\n  display: flex;\n  justify-content: flex-start;\n}\nimg.icon-list-img {\n  margin-right: 30px;\n  width: 50px;\n}\n\nspan.mins-text {\n  color: var(--Primary, #313b2f);\n  font-family: \"Helvetica Neue\", sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.icon-list-title {\n  color: var(--Black, #000);\n  font-family: \"Helvetica Neue\", sans-serif !important;\n  font-size: 20px;\n  font-style: normal !important;\n  font-weight: 300;\n  line-height: 33px !important;\n}\n\n.icon-list-heading {\n  color: var(--Black, #000);\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-transform: uppercase;\n  opacity: 0.6;\n  font-family: \"Helvetica Neue\", sans-serif !important;\n}\n\n.icon-list {\n  margin-bottom: 2rem;\n}\n\n.location-options {\n  flex-basis: 100.333333% !important;\n\n  max-width: 100.333333% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
